// extracted by mini-css-extract-plugin
export default {"userProfile":"user-profile-data-edit_userProfile__uOl5l"};